import { ExperiencePageKeyEnum } from '../types/api';

export const EXPERIENCE = 'experience';

export const PAGE_KEY_MAP: Record<string, ExperiencePageKeyEnum> = {
  '/pick-your-gift': ExperiencePageKeyEnum.PickYourGift,
  '/customize-options': ExperiencePageKeyEnum.PickYourOption,
  '/address': ExperiencePageKeyEnum.ShippingPage,
};
